import {emptyWorkflowAction, emptyWorkflowForm, emptyWorkflowProcess, emptyWorkflowProcessStage, emptyWorkflowProcessType, emptyWorkflowTask, IWorkflowAction, IWorkflowForm, IWorkflowProcess, IWorkflowProcessType, IWorkflowTask} from "@retail-data-factory/rdf-angular-types-api";
import {emptyTranslatedName, ITranslatedName} from "@retail-data-factory/rdf-angular-translation-service";
import * as moment from "moment";

export function mapProcessFromService(item: object): IWorkflowProcess {
  const process: IWorkflowProcess = {
    ...emptyWorkflowProcess,
    id: item['process_id'] !== null && item['process_id'] !== undefined ? item['process_id'].toString() : '',
    name: item['process_name'],
    description: item['process_description'],

    ownerPartyId: item['owner_party_id'] !== null && item['owner_party_id'] !== undefined ? item['owner_party_id'].toString() : '',

    processType: {
      ...emptyWorkflowProcessType,
      id: item['process_definition_id'] !== null && item['process_definition_id'] !== undefined ? item['process_definition_id'].toString() : '',
      code: item['process_definition_code'],
      name: item['process_definition_name']
    },

    statusCode: item['status_code'],

    userIdCreated: item['user_id_created'] !== null && item['user_id_created'] !== undefined ? item['user_id_created'].toString() : '',
    userNameCreated: item['user_name_created'],
    userIdUpdated: item['user_id_updated'] !== null && item['user_id_updated'] !== undefined ? item['user_id_updated'].toString() : '',
    userNameUpdated: item['user_name_updated'],

    userIdTaskAssigned: '',
    userNameTaskAssigned: '',

    dateCreate: item['date_create'] ? moment(item['date_create'], 'YYYYMMDD HH:mm:ss.SSS').toDate() : null,
    dateStart: item['date_start'] ? moment(item['date_start'], 'YYYYMMDD HH:mm:ss.SSS').toDate() : null,
    dateUpdate: item['date_update'] ? moment(item['date_update'], 'YYYYMMDD HH:mm:ss.SSS').toDate() : null,
    dateEnd: item['date_end'] ? moment(item['date_end'], 'YYYYMMDD HH:mm:ss.SSS').toDate() : null,
    dateDue: item['date_due'] ? moment(item['date_due'], 'YYYYMMDD HH:mm:ss.SSS').toDate() : null,
    dateArchive: item['date_archive'] ? moment(item['date_archive'], 'YYYYMMDD HH:mm:ss.SSS').toDate() : null,
    dateLastDecision: item['date_last_event'] ? moment(item['date_last_event'], 'YYYYMMDD HH:mm:ss.SSS').toDate() : null,
    lastDecision: item['last_event'] ? item['last_event'] : '',

    forms: item['forms'] ? item['forms'].map(t => ({
      ...emptyWorkflowForm,
      title: t['title'] ? t['title'] : '',
      tooltip: t['tooltip'] ? t['tooltip'] : '',
      formCode: t['form_code'] ? t['form_code'] : '',
      icon: t['icon'] ? t['icon'] : '',
      profile: t
    })) : [],
    actions: item['actions'] ? item['actions'].map(t => mapAction(t)) : [],


    profile: item['process_profile'],


    //auchan workflow audit

    department: '',
    isDelay: false,
    manager: '',
    sector: '',
    supplier: '',
    whoDelay: '',

    bonusApproved: item['bonus_approved'],
    bonusCalculated: item['bonus_calculated'],
    mmlName: item['mml_name']
  };
  return process;
}

export function mapWorkflowTaskTab(item: object): IWorkflowForm {
  const tab: IWorkflowForm = {
    ...emptyWorkflowForm,
    title: item['title'] ? item['title'] : '',
    tooltip: item['tooltip'] ? item['tooltip'] : '',
    formCode: item['form_code'] ? item['form_code'] : '',
    icon: item['icon'] ? item['icon'] : '',
    profile: item['profile'] ? item['profile'] : {}
  };
  return tab;

}

export function mapTaskFromService(item: object): IWorkflowTask {
  const task: IWorkflowTask = {
    ...emptyWorkflowTask,
    id: item['task_id'].toString(),
    name: item['task_name'] ? item['task_name'] : '',
    description: item['task_description'] ? item[''] : '',
    instructions: item['task_instruction'] ? item['task_instruction'] : '',

    process: {
      ...emptyWorkflowProcess,
      id: item['process_id'] ? item['process_id'].toString() : '',
      name: item['process_name'] ? item['process_name'] : ''
    },
    processType: {
      ...emptyWorkflowProcessType,
      id: item['process_definition_id'] ? item['process_definition_id'].toString() : '',
      code: item['process_definition_code'] ? item['process_definition_code'] : '',
    },
    stage: {
      ...emptyWorkflowProcessStage,
      id: item['stage_id'] ? item['stage_id'] : '',
      typeCode: item['stage_type_code'] ? item['stage_type_code'] : '',
      name: item['stage_name'] ? item['stage_name'] : ''
    },
    statusCode: item['task_status_code'] ? item['task_status_code'] : '',

    userIdCreated: item['user_id_created'] !== null && item['user_id_created'] !== undefined ? item['user_id_created'].toString() : '',
    userNameCreated: item['user_name_created'] ? item['user_name_created'] : '',
    userIdUpdated: item['user_id_updated'] !== null && item['user_id_updated'] !== undefined ? item['user_id_updated'].toString() : '',
    userNameUpdated: item['user_name_updated'] ? item['user_name_updated'] : '',

    userIdAssigned: item['user_id_assigned'] !== null && item['user_id_assigned'] !== undefined ? item['user_id_assigned'].toString() : '',
    userCodeAssigned: item['user_id_assigned'] !== null && item['user_id_assigned'] !== undefined ? item['user_id_assigned'].toString() : '',
    userNameAssigned: item['user_name_assigned'] ? item['user_name_assigned'] : '',


    groupIdAssigned: '',
    groupNameAssigned: '',

    dateCreate: item['date_create'] ? moment(item['date_create'], 'YYYYMMDD HH:mm:ss.SSS').toDate() : null,
    dateStart: item['date_start'] ? moment(item['date_start'], 'YYYYMMDD HH:mm:ss.SSS').toDate() : null,
    dateUpdate: item['date_update'] ? moment(item['date_update'], 'YYYYMMDD HH:mm:ss.SSS').toDate() : null,
    dateComplete: item['date_end'] ? moment(item['date_end'], 'YYYYMMDD HH:mm:ss.SSS').toDate() : null,
    dateDue: item['date_due'] ? moment(item['date_due'], 'YYYYMMDD HH:mm:ss.SSS').toDate() : null,

    forms: item['forms'] ? item['forms'].map(t => ({
      ...emptyWorkflowForm,
      title: t['title'] ? t['title'] : '',
      tooltip: t['tooltip'] ? t['tooltip'] : '',
      formCode: t['form_code'] ? t['form_code'] : '',
      icon: t['icon'] ? t['icon'] : '',
      profile: t
    })) : [],

    actions: item['actions'] ? item['actions'].map(t => mapAction(t)) : [],


    taskVariables: item['task_profile']?item['task_profile']:'',
    processVariables: item['process_profile']?item['process_profile']:'',

    //Ренессанс
    bonusApproved: item['bonus_approved'],
    bonusCalculated: item['bonus_calculated'],
    percentFinished: item['performance_pct'],

    //Шляпа от ашана
    qTitle: '',
    priority: 'unknown',
    isLocked: false,
    assignType: "",
    assignShow: false

  };

  return task;

}

export function mapProcessTypeFromService(item: object): IWorkflowProcessType {
  const processType: IWorkflowProcessType = {
    ...emptyWorkflowProcessType,
    id: item['process_definition_id'] ? item['process_definition_id'].toString() : '',
    code: item['process_definition_code'] ? item['process_definition_code'] : '',
    name: item['process_definition_name'] ? item['process_definition_name'] : '',
    statusCode: item['status_code'] ? item['status_code'] : '',

    userIdCreated: item['user_id_created'] ? item['user_id_created'].toString() : '',
    userNameCreated: item['user_name_created'] ? item['user_name_created'] : '',
    userIdUpdated: item['user_id_updated'] ? item['user_id_updated'].toString() : '',
    userNameUpdated: item['user_name_updated'] ? item['user_name_updated'] : '',

    dateCreate: item['date_create'] ? moment(item['date_create'], 'YYYYMMDD HH:mm:ss.SSS').toDate() : null,
    dateUpdate: item['date_update'] ? moment(item['date_update'], 'YYYYMMDD HH:mm:ss.SSS').toDate() : null,

    forms: item['forms'] ? item['forms'].map(t => ({
      ...emptyWorkflowForm,
      title: t['title'] ? t['title'] : '',
      tooltip: t['tooltip'] ? t['tooltip'] : '',
      formCode: t['form_code'] ? t['form_code'] : '',
      icon: t['icon'] ? t['icon'] : '',
      profile: t
    })) : [],

    actions: item['actions'] ? item['actions'].map(t => mapAction(t)) : [],

    profile: item['process_definition_profile']
  };
  if (processType.profile && processType.profile['rdfParameters'] && processType.profile['rdfParameters']['forms']) {
    processType.forms = processType.profile['rdfParameters']['forms'].map(t => ({
      ...emptyWorkflowForm,
      title: t['title'] ? t['title'] : '',
      tooltip: t['tooltip'] ? t['tooltip'] : '',
      formCode: t['form_code'] ? t['form_code'] : '',
      icon: t['icon'] ? t['icon'] : '',
      profile: t
    }));
  }

  return processType;
}

/**
 * Маппинг действий, который можно произвести с объектом
 * @param t
 */
function mapAction(t: object): IWorkflowAction {
  return {
    ...emptyWorkflowAction,
    id: t['id'] ? t['id'] : '',
    code: t['profile'] && t['profile']['code'] ? t['profile']['code'] : '',
    disabled: t['profile'] && t['profile']['disabled'] ? t['profile']['disabled'] : false,
    title: t['profile'] && t['profile']['title'] ? t['profile']['title'] : '',
    titleTranslation: {...emptyTranslatedName, ...t['profile'] && t['profile']['title_translated'] ? t['profile']['title_translated'] : null},
    typeCode: t['profile'] && t['profile']['type'] ? t['profile']['type'] : '',
    buttonType: t['profile'] && t['profile']['code'] ? t['profile']['button_type'] : '',
    profile: t['profile']
  };
}
